import React, { Component } from 'react'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Box } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import { IconButton } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Avatar, Tooltip } from '@material-ui/core';
import { getCookie } from '../Helper/CookieHelper';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CalenderMini from './CalenderMini';
import TableMini from './TableMini';
import BankHolidays from '../LeaveManagementSystem/LeaveinfoTabs/BankHolidays'
// import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import LeaveCard from './LeaveCard';
import BankHolidayTimesheet from './BankHolidayTimesheet/BankHolidayTimesheet';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}



TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const user = JSON.parse(getCookie("bb_ts_user"));

class UserLeave extends Component {
    constructor(props) {
        super(props)

        this.state = {
            value: 0,
        }
        this.handleData = this.handleData.bind(this);
    }

    handleData(data) {
        this.child.current.dataReceive(data);
        this.leavedetails.current.dataReceive(data);
    }

    render() {
        const goback = () => {

            window.close()
        };
        const avatarClick = (e) => {
            alert("Login Information:\nLogin Provider: BB PaRaM \nUser: " + user.last_name + ', ' + user.first_name + "\nEmail: " + user.email)
        }
        const handleChange = (event, newValue) => {
            this.setState({
                value: newValue
            })
        };
        return (
            <div>
                {
                    this.props.hideAppbar ? null :
                        <AppBar position="fixed">
                            <Toolbar >
                                <IconButton onClick={goback} edge="start" color="inherit" style={{ marginRight: 36 }}>
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" noWrap style={{
                                    flexGrow: 1,
                                    backgroundColor: "#007681",
                                }}>
                                    <Box display="flex" alignItems="flex-end">
                                        Leave Management System<Box style={{ marginLeft: '5px' }} fontSize={10} >Powered by PaRaM</Box>
                                    </Box>

                                </Typography>
                                <Tooltip title="Profile">
                                    <Avatar style={{ marginRight: '0px', backgroundColor: 'orange' }} onClick={e => avatarClick()}>
                                        <Box fontSize={16} fontWeight="fontWeightBold"> {user.last_name.charAt(0) + user.first_name.charAt(0)}</Box>
                                    </Avatar>
                                </Tooltip>

                            </Toolbar>
                        </AppBar>
                }

                <Box style={{ marginTop: this.props.hideAppbar ? '0px' : '60px' }} >
                    <LeaveCard id={user.id} />
                </Box>
                <AppBar position='static' color='secondary'>
                    <Tabs value={this.state.value} style={{ marginTop: '5px', marginLeft: '8px', marginRight: '8px' }} onChange={handleChange} aria-label="simple tabs example"
                        indicatorColor="primary"
                        // textColor="primary"
                        variant="fullWidth"
                        scrollButtons="auto"
                    >
                        <Tab label="Calender View" {...a11yProps(0)} />
                        <Tab label="Table View" {...a11yProps(1)} />
                        <Tab label="Bank Holiday Utilization" {...a11yProps(2)} />
                        <Tab label="Bank Holidays" {...a11yProps(3)} />
                    </Tabs>
                </AppBar>
                <TabPanel value={this.state.value} index={0}>
                    <CalenderMini value={user.id} />
                </TabPanel>
                <TabPanel value={this.state.value} index={1}>
                    <TableMini value={user.id} userinfo={user} />
                </TabPanel>

                <TabPanel value={this.state.value} index={2}>
                    <BankHolidayTimesheet />
                </TabPanel>

                <TabPanel value={this.state.value} index={3}>
                    <BankHolidays newTab={true} off_loc={1} />
                </TabPanel>
                {/* </div> */}
            </div>
        )
    }
}

export default UserLeave